import type { BillingOverviewResponse } from "@/lib/billing/types"

export function shouldShowFreePlanVoiceNotice(
  agent: { status: string },
  billing: BillingOverviewResponse | undefined,
): boolean {
  return agent.status === "disabled"
    && billing?.plan?.price_monthly_cents === 0
    && billing.plan.voice_included === false
}
